export default "/images/c7ca4148d9a4dc69421eef76dd695e8a.avif";